import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { BreakSettingsFormValues } from 'modules/attendance/lib/forms/BreakSettingForm'

interface Props {
  settingForm: FormikProps<BreakSettingsFormValues>
  toggleEnableBreaks: (value: boolean) => void
}

const ManualBreaks = ({ settingForm, toggleEnableBreaks }: Props) => {
  const manualBreaksValue = settingForm.values.manualBreaks

  return (
    <CollapsableCard
      open={false}
      Card={
        <Box gap="s8">
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.breaks.instance.manual_breaks.label')}
            </Text.Normal>
            <TogglerCheckbox
              value={manualBreaksValue}
              onChange={(value) => toggleEnableBreaks(value)}
              labelBefore
            />
          </Box>
          <Text.Normal color="grey800" htmlTag="div">
            {i18n.t('time_tracking.settings.breaks.instance.manual_breaks.description')}
          </Text.Normal>
        </Box>
      }
      Content={<></>}
    />
  )
}

export default observer(ManualBreaks)
